import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

import {QuestionnaireOriginComponent} from './components/origin/questionnaire-origin.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbTooltipModule
  ],
  declarations: [
    QuestionnaireOriginComponent
  ],
  exports: [
    QuestionnaireOriginComponent
  ]
})
export class QuestionnaireOriginModule {
}
